import { styled } from '@mui/material/styles'
import { TableContainer } from '@mui/material'

export const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: '10px',
  boxShadow: '0 6px 20px 0 rgba(55, 55, 55, 0.06)',
}))
